import * as moment from 'moment';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { IPackageListingState } from '../classes/package-listing';
import { IPackageListingAppText } from '../custom/classes/package-listing-text';
import packageListingTextReducer from './reducers/package-text.reducer';
import packageListingReducer from './reducers/package-listing.reducer';
import { IProduction, IPackage } from '../custom/classes/production';
import { loadPackage, updateSettings, loadPackages, loadPackageRequest } from './actions/package-listing.actions';
import { IPackageListingAppSettings } from '../custom/classes/package-listing-settings';
import packageListingSettingsReducer from './reducers/package-settings.reducer';


declare const pageData: any;
declare const packageDetail: any;
declare const packages: any;
declare const packageRequest: any;
declare const packageOriginalSeats: any;

export interface IPackageListingAppState {
    packageListing: IPackageListingState<IPackage>;
    packageListingText: IPackageListingAppText;
    packageListingSettings: IPackageListingAppSettings;
}

const appReducer = combineReducers({
    packageListing: packageListingReducer,
    packageListingText: packageListingTextReducer,
    packageListingSettings: packageListingSettingsReducer
});

//let calendarSettings = {
//    ...defaultCalendarSettings
//};

const appStore = createStore(appReducer, {
    //calendarSettings: calendarSettings
}, applyMiddleware(thunk));

// redux-thunk messes with redux typings.
//appStore.dispatch(getEventsFromApi() as any);


appStore.dispatch(updateSettings(pageData) as any);
if (typeof (packageDetail) === "undefined") {
    appStore.dispatch(loadPackages(packages));
    if (packageRequest) {
        appStore.dispatch(loadPackageRequest(packageRequest, packageOriginalSeats) as any);
    }
} else {
    appStore.dispatch(loadPackage(packageDetail));
}

export { appStore };
